@if (isAuthenticated()) {
  @if (isDesktop()) {
    <app-main-header />
    <app-navigation-bar [isShowCategoryButton]="isShowCategoryButton()" />
  } @else {
    <app-mobile-header />
  }
} @else {
  <app-auth-header />
}
<ng-content />
@if (isAuthenticated()) {
  @if (!isDesktop()) {
    <app-mobile-bottom-nav />
  }
  <app-main-footer />
} @else {
  <app-auth-footer />
}
